// rtuCategory.js
//
// The RTU (ready-to-use) category of a selected target formulation.
//
// Two kinds of RTU product exist and they are NOT interchangeable to a pharmacy:
// commercially manufactured products, and 503B products compounded by outsourcing
// facilities. The same concentration can be offered as both, which is why the
// category is recorded from the picker section the user actually clicked rather
// than re-derived from the formulation string — the string alone can't tell them
// apart.
//
// `null` / '' means no RTU version was selected: a custom formulation, an ASHP
// concentration, or one of the medication's own existing formulations.

export const RTU_COMMERCIAL = 'commercial';
export const RTU_503B = '503b';

/**
 * Display label for an RTU category.
 * @param {string|null} category - 'commercial' | '503b' | null
 * @returns {string} label, or '' when no RTU version was selected
 */
export function rtuCategoryLabel(category) {
  if (category === RTU_503B) return '503B RTU';
  if (category === RTU_COMMERCIAL) return 'Commercial RTU';
  return '';
}

/**
 * Vuetify color token for an RTU category chip.
 * @param {string|null} category
 * @returns {string}
 */
export function rtuCategoryColor(category) {
  return category === RTU_503B ? 'deep-purple' : 'info';
}

/**
 * Noun for the facilities behind an RTU product — 503B products are compounded
 * by outsourcing facilities, not manufactured, so the roll-up label differs.
 * @param {string|null} category
 * @param {number} count
 * @returns {string} e.g. "2 compounders" / "1 manufacturer"
 */
export function rtuFacilityNoun(category, count) {
  if (category === RTU_503B) {
    return count === 1 ? 'compounder' : 'compounders';
  }
  return count === 1 ? 'manufacturer' : 'manufacturers';
}
